var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon404 from './icon-404';
import { Title, Button } from '@patternfly/react-core';
import '../InvalidObject/invalidObject.css';
var isBeta = function () {
    return window.location.pathname.split('/')[1] === 'beta' ? '/beta' : '';
};
var InvalidObject = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement("section", __assign({}, props, { className: "pf-l-page__main-section pf-c-page__main-section ins-c-component_invalid-component" }),
        React.createElement(Title, { headingLevel: "h1", size: "3xl" }, "We lost that page"),
        React.createElement(Icon404, null),
        React.createElement(Title, { headingLevel: "h1", size: "xl", className: "ins-c-text__sorry" }, "Let's find you a new one. Try a new search or return home."),
        React.createElement(Button, { variant: "link", component: "a", href: "".concat(window.location.origin).concat(isBeta()) }, "Return to homepage")));
};
export default InvalidObject;
//# sourceMappingURL=InvalidObject.js.map